/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminQuickSightService {

    /**
     * Get list of report types
     * @returns string Success
     * @throws ApiError
     */
    public static getReportTypes(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/quickSight/reportType',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of analysis
     * @returns any[] Success
     * @throws ApiError
     */
    public static getQuickSightListAnalysis({
        templateType,
        reportType,
        search,
        companyCode,
        sort,
        unassigned,
    }: {
        /**
         * Template Type
         */
        templateType: string,
        /**
         * Report Type
         */
        reportType?: string,
        /**
         * Search
         */
        search?: string,
        /**
         * Company Code
         */
        companyCode?: string,
        /**
         * Sorting
         */
        sort?: {
            lastUpdatedTime?: 'ASC' | 'DESC';
        },
        /**
         * Analyses assignment to tenant
         */
        unassigned?: boolean,
    }): CancelablePromise<any[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/quickSight/analysis',
            query: {
                'reportType': reportType,
                'templateType': templateType,
                'search': search,
                'companyCode': companyCode,
                'sort': sort,
                'unassigned': unassigned,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update analysis
     * @returns any Success
     * @throws ApiError
     */
    public static updateAnalysis({
        requestBody,
    }: {
        requestBody?: {
            analysisArn: string;
            name?: string;
        },
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/quickSight/analysis',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of company codes
     * @returns string Success
     * @throws ApiError
     */
    public static getCompanyCodes(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/quickSight/companyCode',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Promote analysis
     * @returns any[] Success
     * @throws ApiError
     */
    public static promoteAnalysis({
        requestBody,
    }: {
        requestBody?: {
            targetEnv?: string;
            analysisIds?: Array<string>;
        },
    }): CancelablePromise<any[]> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/quickSight/analysis/promote',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get analysis status
     * @returns any Success
     * @throws ApiError
     */
    public static getAnalysisStatus({
        requestBody,
    }: {
        requestBody?: {
            names?: Array<string>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/quickSight/analysis/status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create template
     * @returns any Success
     * @throws ApiError
     */
    public static createTemplate({
        requestBody,
    }: {
        requestBody?: {
            analysisId: string;
            tenant: string;
        },
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/quickSight/template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
